import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU Legion"
      portada="https://fullcomics18.org/img17/touchuukasou-legion-1.jpg"
     paginas={[
  "https://fullcomics18.org/img17/touchuukasou-legion-1.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-2.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-3.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-4.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-5.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-6.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-7.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-8.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-9.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-10.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-11.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-12.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-13.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-14.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-15.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-16.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-17.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-18.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-19.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-20.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-21.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-22.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-23.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-24.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-25.jpg",
  "https://fullcomics18.org/img17/touchuukasou-legion-26.jpg"
]}
      sugeridos={[]}


      info={{
     grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Big Ass", "Big Breasts", "Blowjob", "Cheating", "Digital", "Dilf", "Glasses", "Group", "Harem", "Incomplete MMF Threesome", "Multi-work Series", "Netorare", "Nipple Stimulation", "Prostitution", "Virginity"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU Legion",
  portada: "https://fullcomics18.org/img17/touchuukasou-legion-1.jpg",
  reverso: "https://fullcomics18.org/img17/touchuukasou-legion-13.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Big Ass", "Big Breasts", "Blowjob", "Cheating", "Digital", "Dilf", "Glasses", "Group", "Harem", "Incomplete MMF Threesome", "Multi-work Series", "Netorare", "Nipple Stimulation", "Prostitution", "Virginity"],
    artistas: "Fuetakishi",
  },
};
